'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconAim = {
  top: '0deg',
  up: '0deg',
  right: '90deg',
  bottom: '180deg',
  down: '180deg',
  left: '270deg'
};

var DirectionalIcon = function DirectionalIcon(_ref) {
  var aim = _ref.aim,
      _ref$transform = _ref.transform,
      transform = _ref$transform === undefined ? '' : _ref$transform,
      props = _objectWithoutProperties(_ref, ['aim', 'transform']);

  return _react2.default.createElement(_Icon2.default, _extends({ transform: transform + ' rotate(' + IconAim[aim] + ')' }, props));
};

DirectionalIcon.propTypes = _extends({}, _Icon2.default.propTypes, {
  aim: _propTypes2.default.oneOf(Object.keys(IconAim))
});

DirectionalIcon.defaultProps = _extends({}, _Icon2.default.defaultProps, {
  aim: 'right'
});

exports.default = DirectionalIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0RpcmVjdGlvbmFsSWNvbi5qcyJdLCJuYW1lcyI6WyJJY29uQWltIiwidG9wIiwidXAiLCJyaWdodCIsImJvdHRvbSIsImRvd24iLCJsZWZ0IiwiRGlyZWN0aW9uYWxJY29uIiwiYWltIiwidHJhbnNmb3JtIiwicHJvcHMiLCJwcm9wVHlwZXMiLCJvbmVPZiIsIk9iamVjdCIsImtleXMiLCJkZWZhdWx0UHJvcHMiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7Ozs7OztBQUVBLElBQU1BLFVBQVU7QUFDZEMsT0FBSyxNQURTO0FBRWRDLE1BQUksTUFGVTtBQUdkQyxTQUFPLE9BSE87QUFJZEMsVUFBUSxRQUpNO0FBS2RDLFFBQU0sUUFMUTtBQU1kQyxRQUFNO0FBTlEsQ0FBaEI7O0FBU0EsSUFBTUMsa0JBQWtCLFNBQWxCQSxlQUFrQixPQUF1QztBQUFBLE1BQXBDQyxHQUFvQyxRQUFwQ0EsR0FBb0M7QUFBQSw0QkFBL0JDLFNBQStCO0FBQUEsTUFBL0JBLFNBQStCLGtDQUFuQixFQUFtQjtBQUFBLE1BQVpDLEtBQVk7O0FBQzdELFNBQ0UseURBQU0sV0FBY0QsU0FBZCxnQkFBa0NULFFBQVFRLEdBQVIsQ0FBbEMsTUFBTixJQUE2REUsS0FBN0QsRUFERjtBQUdELENBSkQ7O0FBTUFILGdCQUFnQkksU0FBaEIsZ0JBQ0ssZUFBS0EsU0FEVjtBQUVFSCxPQUFLLG9CQUFVSSxLQUFWLENBQWdCQyxPQUFPQyxJQUFQLENBQVlkLE9BQVosQ0FBaEI7QUFGUDs7QUFLQU8sZ0JBQWdCUSxZQUFoQixnQkFDSyxlQUFLQSxZQURWO0FBRUVQLE9BQUs7QUFGUDs7a0JBS2VELGUiLCJmaWxlIjoiRGlyZWN0aW9uYWxJY29uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IEljb24gZnJvbSAnLi9JY29uJ1xuXG5jb25zdCBJY29uQWltID0ge1xuICB0b3A6ICcwZGVnJyxcbiAgdXA6ICcwZGVnJyxcbiAgcmlnaHQ6ICc5MGRlZycsXG4gIGJvdHRvbTogJzE4MGRlZycsXG4gIGRvd246ICcxODBkZWcnLFxuICBsZWZ0OiAnMjcwZGVnJ1xufVxuXG5jb25zdCBEaXJlY3Rpb25hbEljb24gPSAoeyBhaW0sIHRyYW5zZm9ybSA9ICcnLCAuLi5wcm9wcyB9KSA9PiB7XG4gIHJldHVybiAoXG4gICAgPEljb24gdHJhbnNmb3JtPXtgJHt0cmFuc2Zvcm19IHJvdGF0ZSgke0ljb25BaW1bYWltXX0pYH0gey4uLnByb3BzfSAvPlxuICApXG59XG5cbkRpcmVjdGlvbmFsSWNvbi5wcm9wVHlwZXMgPSB7XG4gIC4uLkljb24ucHJvcFR5cGVzLFxuICBhaW06IFByb3BUeXBlcy5vbmVPZihPYmplY3Qua2V5cyhJY29uQWltKSlcbn1cblxuRGlyZWN0aW9uYWxJY29uLmRlZmF1bHRQcm9wcyA9IHtcbiAgLi4uSWNvbi5kZWZhdWx0UHJvcHMsXG4gIGFpbTogJ3JpZ2h0J1xufVxuXG5leHBvcnQgZGVmYXVsdCBEaXJlY3Rpb25hbEljb25cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/DirectionalIcon.js
// module id = 290
// module chunks = 0